import { createNamedContext } from '@utils';
import { PayoutSetupContextValue, PayoutSetupResetContextValue } from './interfaces';

export const PayoutSetupContext =
  createNamedContext<PayoutSetupContextValue>(undefined, 'PayoutSetup.Context');

export const PayoutSetupResetContext =
  createNamedContext<PayoutSetupResetContextValue>(undefined, 'PayoutSetup.Reset.Context');
